import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Menu, Row, Select } from "antd";

// import {Option} from "antd/es/mentions";
// import productApi from "../../../apis/Product.api";
import moment from "moment";

import CommissionApi from "../../../apis/Commission.api";
import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import BrandCase from "./brand/BrandCase";
import BrandMonth from "./brand/BrandMonth";

const BrandComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  // const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [brandOrderList, setBrandOrderList] = useState([]);

  // const [brandYearList, setBrandYearList] = useState([]);

  const [optionList, setOptionList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectBrand, setSelectBrand] = useState({
    id: "",
    brand_name: "",
    user_id: 1,
  });
  const [navType, setNavType] = useState("month");

  // const [targetYear, setTargetYear] = useState("2023");
  // const [targetMonth, setTargetMonth] = useState("01");
  const [targetYear, setTargetYear] = useState(
    moment().subtract(1, "month").format("YYYY"),
  );
  const [targetMonth, setTargetMonth] = useState(
    moment().subtract(1, "month").format("MM"),
  );
  const [summary, setSummary] = useState({
    total_purchase_amount: 0,
    expected_payment_amount: 0,
    dy_manage_fee: 0,
    sales_fee: 0,
    delivery_manage_fee: 0,
  });

  // const [commissionList, setCommissionList] = useState([]);
  const [brandMonth, setBrandMonth] = useState([]);

  useEffect(() => {
    // setTargetYear(moment().subtract(1, "month").format("YYYY"));
    // setTargetMonth(moment().subtract(1, "month").format("MM"));
    if (user?.role === "super_admin" && optionList?.length === 0) {
      getBrandList();
    }
  }, []);

  // 브랜드 초기값 세팅 (프로메드)
  // useEffect(() => {
  // 	if (!selectBrand.brand_name?.length && !!brandList?.length) {
  // 		setSelectBrand(brandList.filter((item) => item.id === 1)[0]);
  // 	}
  // }, [selectBrand, brandList]);

  useEffect(() => {
    if (targetYear && targetMonth) {
      // getUserOrderList();
      // getBrandYear();
      if (user?.role === "super_admin") {
        if (selectBrand.id) {
          getUserOrderList();
        }
      } else {
        getUserOrderList();
      }
    }
    // if (user?.role === "super_admin" && optionList?.length === 0) {
    // 	getBrandList();
    // }
  }, [user, selectBrand, targetYear, targetMonth, optionList]);

  /**
   * 브랜드 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getBrandList = async () => {
    // setIsLoading(true);

    let param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await CommissionApi.readBrandList(param);
    if (res.code === 200) {
      let result = res.result.filter((item) => item.user_id !== null);
      setBrandList(result);
      setOptionList([
        // {value: "all", label: "전체"},
        ...result.map((item) => ({
          value: item.id,
          label: item.brand_name,
        })),
      ]);
      setSelectBrand(res.result.filter((item) => item.id === 1)[0]);
    }
    // setIsLoading(false);
  };

  /**
   * 브랜드 월별 데이터 가져오기
   * @returns {Promise<void>}
   */
  // const getBrandYear = async () => {
  //     let brandId = user?.role === "super_admin" ?
  //         selectBrand?.user_id ?? 1
  //         : user.id;
  //     let param = {
  //         userId: brandId,
  //         searchYear: targetYear,
  //         super_admin: (user?.role === "super_admin")
  //     }
  //     const res = await CommissionApi.readBrandYear(param);
  //     if (res.code === 200) {
  //         setBrandYearList(res.result);
  //     }
  // }

  // useEffect(() => {
  //     getThisMonthOrder();
  // }, [brandYearList]);
  //
  //
  // const getThisMonthOrder = async () => {
  //     // setIsLoading(true);
  //     let brandId = user?.role === "super_admin" ?
  //         selectBrand?.user_id ?? 1
  //         : user.id;
  //     const res = await salesManageApi.searchOrderDetailList(
  //         0,
  //         10,
  //         "order",
  //         // "payment_created_at",
  //         "complete_date",
  //         moment(`${targetYear}-${targetMonth}`).startOf("month").format("YYYYMMDDHHmm"),
  //         moment(`${targetYear}-${targetMonth}`).endOf("month").format("YYYYMMDDHHmm"),
  //         // "all",
  //         "complete",
  //         "",
  //         "",
  //         "payment_created_at",
  //         "desc",
  //         "",
  //         "",
  //         brandId,
  //         1
  //     );
  //     if (res.code === 200) {
  //         setBrandMonth(res.result.partnersSettlementList ?? []);
  //         let orderDetailList = res.result.userOrderDetailDTOList;
  //         orderDetailList.sort((a, b) => moment(b.created_at) - moment(a.created_at))
  //         let total = 0;
  //         let expected_payment_amount = 0;
  //         let dy_manage_fee = 0;
  //         let sales_fee = 0;
  //         let delivery_manage_fee = 0;
  //         for (let i = 0; i < orderDetailList?.length; i++) {
  //             if (
  //                 orderDetailList[i].order_detail_status === "complete"
  //             ) {
  //                 total += orderDetailList[i].total_price;
  //                 let fee_total = 0;
  //                 if (orderDetailList[i].query) {
  //                     if (orderDetailList[i].is_cooperate) {
  //                         sales_fee += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
  //                         fee_total += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
  //                     } else {
  //                         sales_fee += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].commission_rate * 1.1) / 100));
  //                         dy_manage_fee += Math.round(orderDetailList[i].total_price * 0.11);
  //                         fee_total += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].commission_rate * 1.1) / 100)) + Math.round(orderDetailList[i].total_price * 0.11);
  //                     }
  //                 } else {
  //                     dy_manage_fee += Math.round(orderDetailList[i].total_price * 0.11);
  //                     fee_total += Math.round(orderDetailList[i].total_price * 0.11);
  //                 }
  //                 // if (orderDetailList[i].is_cooperate) {
  //                 //     sales_fee += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
  //                 //     fee_total += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
  //                 // } else {
  //                 //     if (orderDetailList[i].is_influencer) {
  //                 //         sales_fee += Math.round(orderDetailList[i].total_price * (orderDetailList[i].influencer_fee_rate / 100));
  //                 //         fee_total += Math.round(orderDetailList[i].total_price * (orderDetailList[i].influencer_fee_rate / 100));
  //                 //     }
  //                 //     dy_manage_fee += Math.round(orderDetailList[i].total_price * 0.11);
  //                 //     fee_total += Math.round(orderDetailList[i].total_price * 0.11);
  //                 // }
  //                 // if (orderDetailList[i].total_price < orderDetailList[i].delivery_price_baseline) {
  //                 //     delivery_manage_fee += orderDetailList[i].delivery_price * 0.11;
  //                 //     fee_total += orderDetailList[i].delivery_price * 0.11;
  //                 // }
  //                 expected_payment_amount += orderDetailList[i].total_price - fee_total;
  //             }
  //         }
  //         if (brandYearList?.length) {
  //             setCommissionList([
  //                 {
  //                     total_purchase_amount: total,
  //                     expected_payment_amount: expected_payment_amount,
  //                     dy_manage_fee: dy_manage_fee,
  //                     sales_fee: sales_fee,
  //                     delivery_manage_fee: delivery_manage_fee,
  //                     // month: moment().format("MM"),
  //                     month: moment(`${targetYear}-${targetMonth}`).format("MM"),
  //                     profit_amount: dy_manage_fee + sales_fee + delivery_manage_fee,
  //                 }
  //             ])
  //         } else {
  //             setCommissionList([
  //                 {
  //                     total_purchase_amount: total,
  //                     expected_payment_amount: expected_payment_amount,
  //                     dy_manage_fee: dy_manage_fee,
  //                     sales_fee: sales_fee,
  //                     delivery_manage_fee: delivery_manage_fee,
  //                     // month: moment().format("MM"),
  //                     month: moment(`${targetYear}-${targetMonth}`).format("MM"),
  //                     profit_amount: dy_manage_fee + sales_fee + delivery_manage_fee,
  //                 },
  //                 ...brandYearList?.map((item) => (
  //                     {
  //                         ...item,
  //                         month: moment(item?.settlement_month).format("MM"),
  //                     }
  //                 ))
  //             ])
  //         }
  //     } else {
  //         if (brandYearList?.length) {
  //             setCommissionList([
  //                 ...brandYearList?.map((item) => (
  //                     {
  //                         ...item,
  //                         month: moment(item?.settlement_month).format("MM"),
  //                     }
  //                 ))
  //             ])
  //         } else {
  //             setCommissionList([{
  //                 month: moment(`${targetYear}-${targetMonth}`).format("MM"),
  //             }]);
  //         }
  //     }
  // }

  // const [offset, setOffset] = useState(0);
  // const [pageSize, setPageSize] = useState(10);

  /**
   * 브랜드 건별로 가져오기
   * @returns {Promise<void>}
   */
  // const getBrandCase = async () => {
  //     setIsLoading(true);
  //     let brandId = user?.role === "super_admin" ? selectBrand?.user_id ? selectBrand?.user_id : 1 : user.id;
  //
  //     let param = {
  //         offset: offset ?? 0,
  //         pageSize: pageSize ?? 0,
  //         userId: brandId,
  //         searchYear: targetYear,
  //         searchMonth: targetMonth
  //     }
  //
  //     const res = await CommissionApi.readBrandCase(param);
  //     if (res.code === 200) {
  //         let result = res.result;
  //         let fee_total = result.commission_dy + result.commission_sell + result.commission_delivery
  //         setSummary({
  //             total_purchase_amount: result.total_price,
  //             dy_manage_fee: result.commission_dy,
  //             sales_fee: result.commission_sell,
  //             delivery_manage_fee: result.commission_delivery,
  //             expected_payment_amount: result.total_price - fee_total,
  //         })
  //         console.log({
  //             total_purchase_amount: result.total_price,
  //             // expected_payment_amount: expected_payment_amount,
  //             dy_manage_fee: result.commission_dy,
  //             sales_fee: result.commission_sell,
  //             delivery_manage_fee: result.commission_delivery
  //         });
  //         setBrandOrderList(result.userOrderDetailDTOList);
  //     }
  //     setIsLoading(false);
  // }

  /**
   * 건별 리스트 가져오기
   * @returns {Promise<void>}
   */
  const getUserOrderList = async (start, end) => {
    // let offset = start ?? 0;
    // let pageSize = end ?? 10;
    setIsLoading(true);
    let brandId =
      user?.role === "super_admin"
        ? selectBrand?.user_id
          ? selectBrand?.user_id
          : 1
        : user.id;
    let selectBrandId =
      user?.role === "super_admin"
        ? selectBrand?.id
          ? selectBrand?.id
          : 1
        : user.representative_brand_id;
    const res = await salesManageApi.searchOrderDetailList(
      0,
      10,
      "order",
      // "payment_created_at",
      "complete_date",
      moment(`${targetYear}-${targetMonth}`)
        .startOf("month")
        .format("YYYYMMDDHHmm"),
      moment(`${targetYear}-${targetMonth}`)
        .endOf("month")
        .format("YYYYMMDDHHmm"),
      // "all",
      "complete",
      "",
      "",
      0,
      "",
      "",
      "payment_created_at",
      "desc",
      "",
      "",
      brandId,
      selectBrandId,
    );
    if (res.code === 200) {
      setBrandMonth(res.result.partnersSettlementList ?? []);
      let orderDetailList = res.result.userOrderDetailDTOList;
      orderDetailList.sort(
        (a, b) => moment(b.created_at) - moment(a.created_at),
      );
      let total = 0;
      let expected_payment_amount = 0;
      let dy_manage_fee = 0;
      let sales_fee = 0;
      let delivery_manage_fee = 0;
      let list = [];
      // 건별 계산에서 사용 -> [BrandCase] Summary
      for (let i = 0; i < orderDetailList?.length; i++) {
        if (orderDetailList[i].order_detail_status === "complete") {
          // 목록에 추가
          let orderDetailForDelivery = {};
          if (orderDetailList[i].delivery_price_by_order) {
            orderDetailForDelivery = {
              type: 0,
              order_id: orderDetailList[i].order_id,
              order_detail_id: orderDetailList[i].order_detail_id + "-delivery",
              order_detail_status: orderDetailList[i].order_detail_status,
              name: orderDetailList[i].name,
              product_name: "",
              total_price: orderDetailList[i].delivery_price_by_order,
              is_cooperate: false,
              query: null,
              payment_created_at: orderDetailList[i].payment_created_at,
            };
            orderDetailList[i]["type"] = 1;
            list.push(orderDetailList[i]);
            list.push(orderDetailForDelivery);
          } else {
            orderDetailList[i]["type"] = 1;
            list.push(orderDetailList[i]);
          }

          // 수수료 계산
          // sales_fee : 매출 연동 수수료
          // delivery_manage_fee : 배송 관리 수수료
          // dy_manage_fee : 당영 관리 수수료
          total += orderDetailList[i].total_price;
          let fee_total = 0;
          if (orderDetailList[i].query) {
            if (orderDetailList[i].is_cooperate) {
              sales_fee += Math.round(
                orderDetailList[i].total_price *
                  ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100),
              );
              fee_total += Math.round(
                orderDetailList[i].total_price *
                  ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100),
              );

              // 공동구매 시 - 당영 관리 수수료 11%
              if (orderDetailList[i].dy_commission_include) {
                dy_manage_fee += Math.round(
                  orderDetailList[i].total_price * 0.11,
                );
                fee_total += Math.round(orderDetailList[i].total_price * 0.11);
              }
            } else {
              sales_fee += Math.round(
                orderDetailList[i].total_price *
                  ((orderDetailList[i].commission_rate * 1.1) / 100),
              );
              dy_manage_fee += Math.round(
                orderDetailList[i].total_price * 0.11,
              );
              fee_total +=
                Math.round(
                  orderDetailList[i].total_price *
                    ((orderDetailList[i].commission_rate * 1.1) / 100),
                ) + Math.round(orderDetailList[i].total_price * 0.11);
            }
          } else {
            dy_manage_fee += Math.round(orderDetailList[i].total_price * 0.11);
            fee_total += Math.round(orderDetailList[i].total_price * 0.11);
          }
          // 배송비 항목 수수료 계산
          if (Object.keys(orderDetailForDelivery)?.length > 0) {
            total += orderDetailForDelivery.total_price;
            dy_manage_fee += Math.round(
              orderDetailForDelivery.total_price * 0.11,
            );
            expected_payment_amount +=
              orderDetailForDelivery.total_price -
              Math.round(orderDetailForDelivery.total_price * 0.11);
          }
          // if (orderDetailList[i].is_cooperate) {
          //     sales_fee += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
          //     fee_total += Math.round(orderDetailList[i].total_price * ((orderDetailList[i].cooperate_fee_rate * 1.1) / 100));
          // } else {
          //     if (orderDetailList[i].is_influencer) {
          //         sales_fee += Math.round(orderDetailList[i].total_price * (orderDetailList[i].influencer_fee_rate / 100));
          //         fee_total += Math.round(orderDetailList[i].total_price * (orderDetailList[i].influencer_fee_rate / 100));
          //     }
          //     dy_manage_fee += Math.round(orderDetailList[i].total_price * 0.11);
          //     fee_total += Math.round(orderDetailList[i].total_price * 0.11);
          // }
          // if (orderDetailList[i].total_price < orderDetailList[i].delivery_price_baseline) {
          //     delivery_manage_fee += orderDetailList[i].delivery_price * 0.11;
          //     fee_total += orderDetailList[i].delivery_price * 0.11;
          // }
          expected_payment_amount += orderDetailList[i].total_price - fee_total;
        }
      }
      setSummary({
        total_purchase_amount: total,
        expected_payment_amount: expected_payment_amount,
        dy_manage_fee: dy_manage_fee,
        sales_fee: sales_fee,
        delivery_manage_fee: delivery_manage_fee,
      });
      setBrandOrderList(list);
      setIsLoading(false);
    } else {
      setBrandOrderList([]);
      setSummary({
        total_purchase_amount: 0,
        expected_payment_amount: 0,
        dy_manage_fee: 0,
        sales_fee: 0,
        delivery_manage_fee: 0,
      });
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      {user?.role === "super_admin" ? (
        <ContentHeaderComponent title="브랜드 정산조회" />
      ) : (
        <ContentHeaderComponent title="정산조회" />
      )}
      {user?.role === "super_admin" && (
        <Row
          className="content-header-wrap"
          style={{
            height: "auto",
            paddingBottom: "1rem",
          }}
        >
          <Select
            // defaultValue={selectBrand.brand_name}
            value={selectBrand.brand_name}
            onChange={(value) => {
              const list = brandList?.filter((item) => item.id === value);
              setSelectBrand({ ...list[0] });
            }}
            style={{ width: 200, textAlign: "left", color: "#117ffa" }}
            placeholder={"브랜드 선택"}
            options={optionList}
          />
        </Row>
      )}
      <Menu
        className={`commission-nav`}
        mode="horizontal"
        defaultSelectedKeys={["month"]}
        selectedKeys={[navType]}
      >
        <Menu.Item key={`month`} onClick={() => setNavType("month")}>
          월별 정산내역
        </Menu.Item>
        <Menu.Item key={`case`} onClick={() => setNavType("case")}>
          건별 정산내역
        </Menu.Item>
      </Menu>
      <div className="product-register-wrap">
        <div className={`commission-information`}>
          <div
            className={`commission-information-sentences`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <p style={{ fontWeight: "600" }}>정산 프로세스 안내</p>
            <p>
              · 정산 프로세스는 <span>정산예정 > 정산확정 > 정산완료</span>{" "}
              순으로 진행됩니다.
            </p>
            <p>
              · 정산예정 : <span>매월 5~10일</span> 정산예정 금액을 확인하실 수
              있습니다.
            </p>
            <p>
              · 정산확정 : 정산확정 된 금액을 확인 후{" "}
              <span>'정산확정' 버튼</span>을 눌러주시면 15일 정산 입금 후 완료로
              변경됩니다.
            </p>
            <p>
              · 정산완료 : 정산이 완료 된 건에 대해 <span>내역을 확인</span>할
              수 있습니다
            </p>
            {/*<p>· 구매한 상품이 <span>구매확정</span>된 날짜(배송완료일로부터 7일 후)를 기준으로 <span>정산기준일 +1영업</span>일째 되는 날 정산됩니다.</p>*/}
            <p>
              · 수수료는 <span>'당영 관리 수수료'</span> 및{" "}
              <span>'매출연동수수료'</span>가 있습니다.
            </p>
            <p>
              · 당영 관리 수수료: <span>계약 약관</span>에 따라 수수료가
              과금됩니다. *자세한 수수료 안내는 담당자를 통해 확인 가능합니다.
            </p>
            <p>
              · 매출 연동 수수료:{" "}
              <span>당신의 영양제 솔루션(공동구매 및 인플루언서)</span>을 통해
              노출되어 판매가 이루어진 경우 과금됩니다.
            </p>
          </div>
        </div>
        <div className={`commission-information`}>
          <div className={`commission-information-each`}>
            <p className={`title`}>정산정보</p>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/account.png`}
                alt={"정산방식"}
              />
              <div className="text-div">
                <p>정산방식</p>
                <p style={{ fontWeight: 500 }}>계좌이체</p>
              </div>
            </div>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/month.png`}
                alt={"정산주기"}
              />
              <div className="text-div">
                <p>정산주기</p>
                <p style={{ fontWeight: 500 }}>월 정산</p>
              </div>
            </div>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/date.png`}
                alt={"정산예정"}
              />
              <div className="text-div">
                <p>정산예정</p>
                <p style={{ fontWeight: 500 }}>정산기준일 +1 영업일</p>
              </div>
            </div>
          </div>
          <div className={`commission-information-each`}>
            <p className={`title`}>수수료정보</p>
            <div className={`each-image`}>
              <img
                src={`${process.env.REACT_APP_HOST}/assets/images/commission/fee.png`}
                alt={"당영관리수수료"}
              />
              <div className="text-div">
                <p>당영 관리 수수료</p>
                <p style={{ fontWeight: 500 }}>
                  11% <span>(VAT포함)</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {navType === "month" ? (
          <BrandMonth
            targetYear={targetYear}
            setTargetYear={setTargetYear}
            targetMonth={targetMonth}
            setTargetMonth={setTargetMonth}
            setNavType={setNavType}
            summary={summary}
            // brandYearList={brandYearList}
            selectBrand={selectBrand}
            brandMonth={brandMonth}
            getUserOrderList={getUserOrderList}
          />
        ) : (
          <BrandCase
            targetYear={targetYear}
            setTargetYear={setTargetYear}
            targetMonth={targetMonth}
            setTargetMonth={setTargetMonth}
            summary={summary}
            brandOrderList={brandOrderList}
          />
        )}
      </div>
    </>
  );
};
export default BrandComponent;
